export default [
  {
    text: 'Name',
    value: 'firstName',
    width: '250px',
    sortable: true,
    order: 1,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Roles',
    value: 'roles',
    sortable: false,
    order: 2,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Active',
    value: 'isSuspended',
    align: 'left',
    sortable: true,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Email',
    value: 'email',
    sortable: false,
    order: 4,
    hidable: true,
    hidden: false,
  },
  // {
  //   text: 'Phone',
  //   value: 'phoneNumber',
  //   sortable: false,
  //   order: 5,
  //   hidable: true,
  //   hidden: false,
  // },
  {
    text: 'Join Date',
    value: 'joinDate',
    width: '150px',
    sortable: true,
    order: 6,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Actions',
    value: 'actions',
    width: '60px',
    sortable: false,
    order: 7,
    hidable: true,
    hidden: false,
  },
];
